import { laceParts6 } from './parts/laceParts'

export const laceOfNetWeb = (ctx: CanvasRenderingContext2D, laceColor: string): void => {
  // ネットウェブ用の革紐最右
  laceParts6(ctx, laceColor, -2, -25) // 上1
  laceParts6(ctx, laceColor, 0, 0) // 上2
  laceParts6(ctx, laceColor, 5, 27) // 上3
  laceParts6(ctx, laceColor, 8, 55) // 上4
  laceParts6(ctx, laceColor, 14, 84) // 上5
}

export const laceOfcrossWebWithHalfNet = (ctx: CanvasRenderingContext2D, laceColor: string): void => {
  // ネットウェブ用の革紐最右
  laceParts6(ctx, laceColor, 20, 84) // 上1
  laceParts6(ctx, laceColor, 23, 107) // 上2
}
